import React from "react";
import { useOutletContext } from "react-router-dom";
import type { TeacherProfile } from "./types";

type OutletContext = { teacher: TeacherProfile | null };

const TeacherSettings: React.FC = () => {
  const { teacher } = useOutletContext<OutletContext>();

  return (
    <div className="space-y-6">
      <section className="rounded-[30px] border border-slate-200 bg-white p-6 shadow-sm">
        <p className="text-xs font-black uppercase tracking-wide text-blue-600">Teacher Settings</p>
        <h2 className="mt-2 text-3xl font-black text-slate-950">Profile and account information</h2>
        <p className="mt-2 text-sm font-bold text-slate-500">
          Profile edit admin approval ke saath add karna best rahega. Abhi read-only overview diya hai.
        </p>
      </section>

      <section className="rounded-[30px] border border-slate-200 bg-white p-6 shadow-sm">
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
          <Info label="Name" value={teacher?.name || "-"} />
          <Info label="Email" value={teacher?.email || "-"} />
          <Info label="Phone" value={teacher?.phone || "-"} />
          <Info label="Subject" value={teacher?.subject || "General"} />
          <Info label="Experience" value={teacher?.experience || "-"} />
          <Info label="Status" value={teacher?.status || "-"} />
        </div>

        <div className="mt-6 rounded-2xl bg-slate-50 p-5">
          <p className="text-xs font-black uppercase tracking-wide text-slate-400">Bio</p>
          <p className="mt-2 text-sm font-bold leading-6 text-slate-600">{teacher?.bio || "No bio added yet."}</p>
        </div>
      </section>
    </div>
  );
};

const Info = ({ label, value }: { label: string; value: string }) => (
  <div className="rounded-2xl bg-slate-50 p-4">
    <p className="text-xs font-bold uppercase tracking-wide text-slate-400">{label}</p>
    <p className="mt-1 break-words text-sm font-black text-slate-900">{value}</p>
  </div>
);

export default TeacherSettings;
